export default "__VITE_ASSET__0mJSi_qK__"